import {
  Button,
  Drawer,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Typography,
} from 'antd';
import { LinkButton } from 'components';
import locale from 'locales';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { AiOutlineDown } from 'react-icons/ai';
import { changeStateOfApproval, getDocuments } from 'services/session';
import Detail from './Detail';

const renderTagColor = (approval) => {
  let type;
  if (approval === '처리 완료') {
    type = 'success';
  } else if (approval === '처리 대기') {
    type = 'default';
  } else if (approval === '처리 중') {
    type = 'processing';
  } else if (approval === '반려') {
    type = 'error';
  }
  return type;
};

// const ApprovalStep = ({ approvers }) => {
//   return (
//     <Popover
//       title="결재 상황"
//       size="small"
//       content={
//         <List
//           size="small"
//           dataSource={approvers}
//           renderItem={(item) => (
//             <List.Item>
//               <Space style={{ justifyContent: 'space-between' }}>
//                 <Tag color={renderTagColor(item.approval)}>{item.approval}</Tag>
//                 <div>{item.name}</div>
//                 <div style={{ width: 140 }}>{item.date}</div>
//               </Space>
//             </List.Item>
//           )}
//         />
//       }
//     >
//       <Space size={4}>{approvers.map((item) => item.name).join(' > ')}</Space>
//     </Popover>
//   );
// };

function Request() {
  const [detail, setDetail] = useState(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tableDataSource, setTableDataSource] = useState([]);
  const [rerendering, setRerendering] = useState(true);
  const [typeFilter, setTypeFilter] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {
    if (!rerendering) {
      return;
    }

    // api
    getDocuments(typeFilter).then((data) => {
      setRerendering(false);
      setTableDataSource(data);
    });
  }, [rerendering]);

  const columns = [
    {
      title: '신청 내용',
      dataIndex: 'type',
      render: (text, record) => (
        <LinkButton onClick={() => setDetail(record)}>{locale[text]}</LinkButton>
      ),
    },
    {
      title: '상태',
      dataIndex: 'state',
      width: 180,
      render: (text) => <Tag color={renderTagColor(text)}>{locale[text]}</Tag>,
    },
    {
      title: '신청 일시',
      dataIndex: 'applyDate',
      width: 180,
      render: (text) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    // {
    //   title: '처리 일자',
    //   dataIndex: 'approveDate',
    //   width: 180,
    //   render: (text) => text || '처리되지 않음',
    // },
  ];

  const onSelectChange = (keys) => {
    setSelectedRowKeys(keys);
  };

  const rowSelection = { selectedRowKeys, onChange: onSelectChange };

  const approvalCancel = async () => {
    const resultArray = [];
    selectedRowKeys.forEach((key) => {
      const temp = tableDataSource.filter((data) => data.id === key);
      if (temp.length > 0) {
        resultArray.push(temp[0].id);
      }
    });

    const result = {
      ids: resultArray,
      state: 'approval.state.cancelled',
    };

    const res = await changeStateOfApproval(result);

    if (res.data.status === 'error') {
      Modal.error({
        title: '신청 취소 실패',
        content: '신청 취소는 대기 중 상태에서만 가능합니다.',
      });
    }

    setSelectedRowKeys([]);
    setRerendering(true);
  };

  const onClose = () => {
    setRerendering(true);
    setDetail(undefined);
  };

  const RegisterMenu = () => {
    const menus = [
      'approval.types.create-vd',
      'approval.types.change-spec-vd',
      'approval.types.delete-vd',
      'approval.types.reset-vd',
      // 'Disk 신청',
      // 'Disk 용량변경 신청',
      // 'Disk 권한추가 신청',
      // 'Disk 사용기간 변경 신청',
      // 'Disk 폐기 신청',
      // '파일다운로드 신청',
      // '파일다운로드 신청(긴급)',
      // '파일다운로드 신청(대용량)',
      // '파일다운로드 신청(Tranzfile)',
      // '파일업로드 신청',
      // '파일업로드 신청(대용량)',
    ];
    return (
      <Menu>
        {menus.map((type, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Menu.Item key={index}>
            <Button type="text" onClick={() => setDetail({ type })}>
              {locale[type]}
            </Button>
          </Menu.Item>
        ))}
      </Menu>
    );
  };

  return (
    <>
      <Table
        title={() => (
          <Space style={{ width: '100%', justifyContent: 'space-between' }}>
            <Space>
              <Dropdown overlay={RegisterMenu}>
                <Button>
                  <span>신청하기</span>
                  <AiOutlineDown className="anticon" />
                </Button>
              </Dropdown>
              <Button
                disabled={!(selectedRowKeys.length > 0)}
                onClick={() => {
                  Modal.confirm({
                    title: '선택된 항목들을 신청 취소하시겠습니까?',
                    content: (
                      <Typography.Text type="danger">
                        해당 작업은 되돌릴 수 없습니다.
                      </Typography.Text>
                    ),
                    okType: 'danger',
                    onOk: approvalCancel,
                  });
                }}
              >
                신청 취소
              </Button>
            </Space>
            <Input.Group compact>
              <Select
                defaultValue=""
                style={{ width: 170 }}
                options={[
                  { label: '전체', value: '' },
                  {
                    label: locale['approval.types.create-vd'],
                    value: 'approval.types.create-vd',
                  },
                  {
                    label: locale['approval.types.change-spec-vd'],
                    value: 'approval.types.change-spec-vd',
                  },
                  { label: locale['approval.types.reset-vd'], value: 'approval.types.reset-vd' },
                  {
                    label: locale['approval.types.delete-vd'],
                    value: 'approval.types.delete-vd',
                  },
                ]}
                onSelect={(value) => {
                  setRerendering(true);
                  setTypeFilter(value !== '' && { type: value });
                }}
              />
            </Input.Group>
          </Space>
        )}
        size="small"
        rowKey="id"
        dataSource={tableDataSource}
        columns={columns}
        rowSelection={rowSelection}
      />
      <Drawer
        title={
          <Space>
            <div>서비스 신청:</div>
            {locale[detail?.type]}
          </Space>
        }
        visible={detail}
        onClose={() => {
          onClose();
          form.resetFields();
        }}
        width={780}
        // bodyStyle={{ maxHeight: 'calc(100vh - 308px)', overflowY: 'auto' }}
        footer={
          <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => {
                onClose();
                form.resetFields();
              }}
            >
              닫기
            </Button>
            {detail?.id &&
              detail?.state !== 'approval.state.cancelled' &&
              detail?.state === 'approval.state.waiting' && (
                <>
                  <Button
                    onClick={async () => {
                      Modal.confirm({
                        title: '선택된 항목들을 신청 취소하시겠습니까?',
                        content: (
                          <Typography.Text type="danger">
                            해당 작업은 되돌릴 수 없습니다.
                          </Typography.Text>
                        ),
                        okType: 'danger',
                        onOk: async () => {
                          selectedRowKeys.push(detail.id);
                          approvalCancel();
                          onClose();
                        },
                      });
                    }}
                  >
                    신청 취소
                  </Button>
                  <Button
                    type="primary"
                    onClick={async () => {
                      try {
                        await form.validateFields();
                        form.submit();
                      } catch (e) {
                        // eslint-disable-next-line no-console
                        console.warn('validate fail', e);
                      }
                    }}
                  >
                    수정
                  </Button>
                </>
              )}
            {!detail?.id && (
              <Button
                type="primary"
                onClick={async () => {
                  try {
                    await form.validateFields();
                    form.submit();
                  } catch (e) {
                    // eslint-disable-next-line no-console
                    console.warn('validate fail', e);
                  }
                }}
              >
                신청
              </Button>
            )}
          </Space>
        }
      >
        <Detail
          approvalType={detail?.type}
          readOnly={detail?.state !== 'approval.state.waiting' && detail?.id}
          id={detail?.id}
          form={form}
          onClose={onClose}
        />
      </Drawer>
    </>
  );
}

export default Request;
